/// <reference path="../../meevoMessenger.module.ts" />

module Meevo.Plugins.MeevoMessenger {
    class PhoneNumberLookupModalController {

        static $inject = [
            'checkNumberEligibility',
            '$mdDialog'
        ];

        public phoneNumber: string;
        public isLoading: boolean = false;
        public eligibilityChecked: boolean = false;
        public isEligible: boolean;

        constructor(
            private checkNumberEligibility: (phoneNumber: string) => ng.IPromise<any>,
            private $mdDialog: angular.material.IDialogService
        ) { }

        check(): void {

            this.isLoading = true;
            this.eligibilityChecked = false;

            let e164Number = '';
            try {
                const phoneInput = $("#meevo-messenger-user-name input[type='tel']");
                if (phoneInput && phoneInput.length && (<any>window).intlTelInputUtils) {
                    e164Number = phoneInput.intlTelInput('getNumber', (<any>window).intlTelInputUtils.numberFormat.E164);
                } else {
                    e164Number = this.phoneNumber;
                }
            } catch (e) {
                e164Number = this.phoneNumber;
            }

            this.checkNumberEligibility(e164Number)
                .then((response: any) => {
                    this.isEligible = response.canBeHosted;
                    this.eligibilityChecked = true;
                })
                .catch(() => {
                    this.isEligible = false;
                    this.eligibilityChecked = true;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

        cancel(): void {
            this.$mdDialog.hide();
        }

    }

    angular.module('meevo.plugins.meevoMessenger')
        .controller('meevo.plugins.meevoMessenger.PhoneNumberLookupModalController', PhoneNumberLookupModalController);
}
